import _ from 'lodash'

import { BATCH_MAINTENANCE } from '@/api/apiModules'
export default {
  viewType: 'form',
  module: BATCH_MAINTENANCE,
  params: {},
  callBackAction: 'OkActionCb',
  toolbar: {
    items: [
      {
        slot: 'left',
        label: '执行导出',
        props: {
          type: 'primary',
          icon: 'sk-icon-export'
        },
        action: 'ExportData'
      },
      {
        slot: 'left',
        label: '执行导入',
        props: {
          type: 'success',
          icon: 'sk-icon-import'
        },
        action: 'ImportData'
      }
    ],
    tips: {
      label: [
        '注意：',
        '1、由于批量运维数据量大，建议在晚上或周末进行，以免异常影响系统使用',
        '2、批量运维配置数据，需要先选择行业，并执行导出后再通过生成的在线表格链接进行编辑，完成后再执行导入操作',
        '3、批量运维数据不可恢复，请谨慎操作'
      ],
      type: 'error'
    }
  },
  needFetchFillInfo: false,
  fillDetailUrl: `/batch/maintenance/getStatus`,
  view: {
    showOkBtn: false,
    showCancelBtn: false,
    labelPosition: 'right',
    labelWidth: '125px',
    width: '975px',
    content: [
      {
        $id: 'industryId',
        $type: 'radio-button',
        label: '行业',
        $default: null,
        params: {
          unPage: true
        },
        $el: {},
        $options: 'projectInfo/industry/list',
        dataType: 'asyn',
        format: function(meta, value) {
          const _options = _.isArray(meta.$options) && meta.$options.length > 0 ? meta.$options : []
          meta.$options = _options.map(item => {
            return {
              value: item.id,
              label: item.industryName
            }
          })

          return value ? value : ''
        },
        rules: [
          {
            notEmpty: 'pocMng.industryEmpty'
          }
        ]
      },
      {
        $id: 'batchMaintenanceUrl',
        $type: 'sky-batch-maintenance-url-link',
        $el: {
          // msg: '',
          // maintenance: {},
          buildStatus: ''
        }
      }
    ]
  }
}
